export const SideBarData =[
  {
    title:'HOME',
    path:'/'
  },
  {
    title:'PROJECTS',
    path:'projects'
  },
  {
    title:'CONTACT',
    path:'contact'
  },
  {
    title: 'RESUME',
    path: 'resume'
  }
]